import { render, staticRenderFns } from "./ProfileInactiveForms.vue?vue&type=template&id=0b5e4f44&"
import script from "./ProfileInactiveForms.vue?vue&type=script&lang=js&"
export * from "./ProfileInactiveForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports